export default {
    USERDETAIL: "USERDETAIL",
    BUYPRICE: "BUYPRICE",
    ADDRESSES: "ADDRESSES",
    AUTHORIZED: "AUTHORIZED"
};